import { ChipProps } from '@mui/material';
import { useGetCustomFieldsForSchoolQuery } from '@schooly/api';
import { Spin, TagSelect } from '@schooly/style';
import { FC, useMemo } from 'react';

export type CustomFieldTagSelectProps = {
  id: string;
  schoolId: string;
} & Omit<ChipProps, 'label'>;

export const CustomFieldTagSelect: FC<CustomFieldTagSelectProps> = ({ id, schoolId, ...props }) => {
  const { data: customFields } = useGetCustomFieldsForSchoolQuery({ schoolId });

  const customField = useMemo(() => customFields?.find((cf) => cf.id === id), [customFields, id]);

  return <TagSelect label={customField?.label ?? <Spin />} {...props} />;
};
